/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["create-subscription-panel{display:block}create-subscription-panel .mat-tab-body{padding:25px}create-subscription-panel .paypal-tab{padding-bottom:5px}create-subscription-panel .paypal-tab>p{background-color:#fafafa;border-radius:4px;padding:15px;border:1px solid #eff1f2}"];
export { styles as styles };
